// extracted by mini-css-extract-plugin
export default {"previewSelfDiagnosis":"previewDiagnosisResultModalIcon_previewSelfDiagnosis__V6QpB"};